//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'SfIcon',
  props: {
    icon: {
      type: [String, Array],
      default: '',
    },
    size: {
      type: String,
      default: '', // px, em, rem, vw, vh, %, etc.
    },
    color: {
      type: String,
      default: '', // hex/rbg/rgba/any color type
    },
    viewBox: {
      type: String,
      default: '0 0 24 24',
    },
    coverage: {
      type: [String, Number],
      default: 1,
    },
  },
  data() {
    return {
      iconFile: null,
      isLoaded: false,
    };
  },
  computed: {
    iconCustomStyle() {
      return {
        '--icon-color': this.color,
        '--icon-size': this.size,
      };
    },
    isSFIcons() {
      return typeof this.icon === 'string' && this.iconFile ? true : null;
    },
    iconViewBox() {
      return this.isSFIcons
        ? this.iconFile.viewBox || this.viewBox
        : this.viewBox;
    },
    iconPaths() {
      if (this.isSFIcons) {
        return this.iconFile.hasOwnProperty('paths')
          ? this.iconFile.paths
          : (Array.isArray(this.iconFile)
            ? this.iconFile
            : [this.iconFile]);
      }
      return Array.isArray(this.icon) ? this.icon : [this.icon];
    },
    fillPath() {
      return this.coverage === 1
        ? 'var(--icon-color)'
        : this.fillPathUrl(this._uid);
    },
  },
  watch: {
    icon: {
      immediate: true,
      handler(value) {
        if (value) {
          // checks if icon file name passed, otherwise load icon path
          if (!new RegExp('[A-Z]+\\d+').test(value)) {
            this.isLoaded = true;
            import(
              /* webpackChunkName: "icon-[request]" */ `~/components/StorefrontUi/icons/${value}`
            )
              .then((module) => module.default)
              .then((icon) => {
                this.iconFile = icon;
                this.isLoaded = false;
              });
          } else {
            this.iconFile = value;
          }
        }
      },
    },
  },
  methods: { fillPathUrl(uid) { return `url(#linearGradient-${uid})`; } },
};
